module.exports = __webpack_public_path__ + "f19db59b856a78921b56d204c4ec55a5.png";